"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.timezones = void 0;

var _momentTimezone = _interopRequireDefault(require("moment-timezone"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var timezones = _momentTimezone.default.tz.names().map(function (value) {
  return {
    value: value,
    utc: "(UTC".concat(_momentTimezone.default.tz(value).format("Z"), ")"),
    offset: _momentTimezone.default.tz(value).utcOffset()
  };
}).sort(function (a, b) {
  return a.offset - b.offset;
});

exports.timezones = timezones;